import * as React from "react";
import { forwardRef } from "react";
const SvgOnelogin = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 10, fill: "#39b54a" }), /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeWidth: 2, d: "M8 12h8m-4-4v8" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 2, fill: "#fff" }));
const ForwardRef = forwardRef(SvgOnelogin);
export default ForwardRef;
